module.exports = __webpack_public_path__ + "static/an-abstract-poem-of-freedom_detail2-2009-8d6c0361a1bbbe24b841bc7bf3d11b38.jpg";